import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPasswordRequest } from '../../lib/api/auth';
import {
  AuthError,
  AuthField,
  AuthShell,
  AuthSubmit
} from './components/AuthForm';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      const result = await forgotPasswordRequest({ email });
      setSent(result.message);
    } catch (requestError) {
      setError(requestError.message || 'Unable to send a reset link right now.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      eyebrow="ACCOUNT RECOVERY"
      subtitle="We'll email you a reset link. Links expire after 30 minutes."
      title="Reset your password"
    >
      {sent ? (
        <div className="auth-success" role="status">
          {sent}
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <AuthField
            autoComplete="email"
            id="forgot-email"
            label="Work email"
            onChange={setEmail}
            placeholder="you@company.com"
            type="email"
            value={email}
          />
          <AuthError message={error} />
          <AuthSubmit busy={busy}>Send reset link</AuthSubmit>
        </form>
      )}

      <div className="auth-links">
        <Link to="/login">Back to sign in</Link>
      </div>
    </AuthShell>
  );
}

export default ForgotPasswordPage;
